import { render, staticRenderFns } from "./ResponsivePage.vue?vue&type=template&id=382e4c8e&scoped=true"
import script from "./ResponsivePage.vue?vue&type=script&lang=js"
export * from "./ResponsivePage.vue?vue&type=script&lang=js"
import style0 from "./ResponsivePage.vue?vue&type=style&index=0&id=382e4c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e4c8e",
  null
  
)

export default component.exports